import { render, staticRenderFns } from "./NewUserForm.vue?vue&type=template&id=53703a1a&"
import script from "./NewUserForm.vue?vue&type=script&lang=ts&"
export * from "./NewUserForm.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./NewUserForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports